import { IUser } from '../common';
import { RequestStatus } from '../admin';
import { Request } from '.';
import AccountActivation from './AccountActivation';
import PasswordReset from './PasswordReset';

export const panels = ({ user, rpsPage, operationsPage }: { user: IUser, rpsPage?: boolean, operationsPage?: boolean }) =>
  operationsPage ?
    [
      (import.meta.env.VITE_ACCOUNT_ACTIVATION_FEATURE === 'ENABLED' && {
        value: 0,
        panel: () => (
          <AccountActivation
          />
        ),
      }),
      (import.meta.env.VITE_ACCOUNT_ACTIVATION_FEATURE === 'ENABLED' && {
        value: 1,
        panel: () => (
          <PasswordReset
          />
        ),
      }),
    ] :
    [{
      value: 0,
      panel: () => (
        <Request
          user={user}
          searchUsers={false}
          forRegistrantsNCoordinators={false}
          raTab={false}
        />
      ),
    },
    {
      value: 1,
      panel: () => (
        <RequestStatus
          di={false}
          requestorEmail=""
          disableOperationsHelpDsk={false}
        />
      ),
    },
    // ((import.meta.env.VITE_ACCOUNT_ACTIVATION_FEATURE === 'ENABLED' && !rpsPage) && {
    //   value: 2,
    //   panel: () => (
    //     <AccountActivation
    //     />
    //   ),
    // }),
    // ((import.meta.env.VITE_ACCOUNT_ACTIVATION_FEATURE === 'ENABLED' && !rpsPage) && {
    //   value: 3,
    //   panel: () => (
    //     <PasswordReset
    //     />
    //   ),
    // }),
    ];
